export const SITESETUP_SET_SELECTED_TAB = 'SITESETUP_SET_SELECTED_TAB';
export const SITESETUP_GRID_LOADING = 'SITESETUP_GRID_LOADING';
export const SITESETUP_SET_SHOW_ISLICENSED = 'SITESETUP_SET_SHOW_ISLICENSED';
export const SITESETUP_SET_SHOW_ISACTIVE = 'SITESETUP_SET_SHOW_ISACTIVE';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/settings/types.js